import lazyload from '@global/composable/lazyload/useLazyPlugin';

const LazyPlugin = {};

LazyPlugin.install = (Vue) => {
  Vue.directive('lazy', lazyload);
};

export default LazyPlugin;
